import { $fetch } from 'vfetcher/ofetch'
// OLD: import router from "@/router";
import { getUser } from "@/store/userauth/store.js";
import { useToast } from "primevue/usetoast";
import { triggerSessionExpired } from "@/services/errorServices/sessionExpired";

/**
 * Vue plugin that registers two pre-configured `$fetch` instances as global
 * properties, one per backend ("Doug Jones" and "Allen Jackson"), each tagged
 * with an identifying header and wired to trigger the session-expired flow
 * on 401/403 responses.
 */
export default {
  /**
   * Installs the plugin, attaching `$apiDougJones` and `$apiAllenJackson`
   * to `app.config.globalProperties`.
   * @param {import('vue').App} app the Vue application instance
   * @param {Object} [options] plugin install options (currently unused)
   */
  install: (app, options) => {
    // $apiDougJones: client for the Doug Jones backend, mounted at /api
    app.config.globalProperties.$apiDougJones = $fetch.create({
      baseURL: '/api',
      headers:{
        "Dougjones": "web",
      },
      // Logs outgoing requests when running in development mode.
      onRequest({ request, options }) {
        // Only log API requests in development mode
        if (import.meta.env.MODE === 'development') {
          // console.log("Intercepted API", request);
        }
      },
      // On auth failure (401) or forbidden (403), trigger the app-wide session-expired handler.
      async onResponseError({ response }) {
        // OLD:
        // if (response.status === 401) {
        //   router.push('/');
        // }
        // else if (response.status === 403) {
        //   router.push('/');
        // }
        if (response.status === 401 || response.status === 403) {
          triggerSessionExpired();
        }
      }
    })

    // $apiAllenJackson: client for the Allen Jackson backend, mounted at /allen-jackson-api
    app.config.globalProperties.$apiAllenJackson = $fetch.create({
      baseURL: '/allen-jackson-api',
      headers: {
        "AllenJackson": "web",
      },
      // Logs outgoing requests when running in development mode.
      onRequest({ request, options }) {
        if (import.meta.env.MODE === 'development') {
          // console.log("Intercepted Allen Jackson API", request);
        }
      },
      // On auth failure (401) or forbidden (403), trigger the app-wide session-expired handler.
      async onResponseError({ response }) {
        // OLD:
        // if (response.status === 401) {
        //   router.push('/');
        // } else if (response.status === 403) {
        //   router.push('/');
        // }
        if (response.status === 401 || response.status === 403) {
          triggerSessionExpired();
        }
      }
    })
  }
}
